function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import BaseButton from './BaseButton';
import IconButtonGy from './IconButtonGy';
import LinkButton from './LinkButton';
import SplitButton from './SplitButton';
import { basePropTypes, StyledButton } from './utils';
import { AddOutlinedIcon, EditIcon } from '../icons';
const ContainedButton = props => /*#__PURE__*/React.createElement(BaseButton, _extends({
  variant: "contained"
}, props));
const OutlinedButton = props => /*#__PURE__*/React.createElement(BaseButton, _extends({
  variant: "outlined"
}, props));
const TextButton = props => /*#__PURE__*/React.createElement(BaseButton, props);
const CreateButton = props => /*#__PURE__*/React.createElement(ContainedButton, _extends({}, props, {
  color: props.color || 'primary',
  text: props.text || 'Create'
}));
const SaveButton = props => /*#__PURE__*/React.createElement(ContainedButton, _extends({}, props, {
  type: "submit",
  color: props.color || 'primary',
  text: props.text || 'Save'
}));
const CancelButton = props => /*#__PURE__*/React.createElement(OutlinedButton, _extends({}, props, {
  color: props.color || 'secondary',
  text: props.text || 'Cancel'
}));
const IconButtonAdd = props => /*#__PURE__*/React.createElement(IconButtonGy, _extends({}, props, {
  icon: AddOutlinedIcon,
  label: props.label || 'Add'
}));
const IconButtonEdit = props => /*#__PURE__*/React.createElement(IconButtonGy, _extends({}, props, {
  icon: EditIcon,
  label: props.label || 'Edit'
}));
const CustomButton = _ref => {
  let {
    text,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledButton, rest, text, children);
};
const IconTextButton = props => /*#__PURE__*/React.createElement(BaseButton, _extends({}, props, {
  color: "primary",
  variant: "contained",
  startIcon: props === null || props === void 0 ? void 0 : props.icon
}), props === null || props === void 0 ? void 0 : props.text);
const IconTextButtonNonPrimary = props => /*#__PURE__*/React.createElement(BaseButton, _extends({}, props, {
  variant: "contained",
  startIcon: props === null || props === void 0 ? void 0 : props.icon
}), props === null || props === void 0 ? void 0 : props.text);
CustomButton.propTypes = basePropTypes;
ContainedButton.propTypes = basePropTypes;
TextButton.propTypes = basePropTypes;
LinkButton.propTypes = basePropTypes;
CreateButton.propTypes = {
  ...basePropTypes,
  float: PropTypes.string
};
OutlinedButton.propTypes = basePropTypes;
SaveButton.propTypes = basePropTypes;
CancelButton.propTypes = basePropTypes;
IconButtonAdd.propTypes = {
  ...basePropTypes,
  children: PropTypes.any,
  label: PropTypes.string
};
IconButtonEdit.propTypes = {
  ...basePropTypes,
  children: PropTypes.any,
  label: PropTypes.string
};
export { CustomButton, TextButton as Button, ContainedButton, TextButton, LinkButton, OutlinedButton, SaveButton, CancelButton, CreateButton, IconButtonGy as IconButton, IconButtonAdd, IconButtonEdit, SplitButton, IconTextButton, IconTextButtonNonPrimary };